import "./index.scss";
import { MenuProps } from "./types";
import MenuDefault from "./MenuDefault";
import React from "react";

const Menu = ({ data }: MenuProps) => {
  const menuActive = data.content[0];
  return (
    data && (
      <nav className="menu" role="navigation">
        {/* SWITCH FOR MenuSidebar */}
        <MenuDefault data={menuActive} />
      </nav>
    )
  );
};

export default Menu;
